// Footer.js

import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css"

function Footer() {
  return (
    <footer className="bg-gray-900 text-lavender  py-12">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4 md:px-0 ">
        <div className="footer-section m-auto">
          <h3 className="text-xl md:text-2xl font-bold mb-4">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/categories">Categories</Link></li>
            <li><Link to="/about" className="disabled">About Us</Link></li>
            <li><Link to="/contact" className="disabled">Contact Us</Link></li>
            <li><Link to="https://webgeniuscraft.com" target="_blank" className="mainWebsiteLink">WebGeniusCraft</Link></li>
          </ul>
        </div>
        <div className="footer-section m-auto">
          <h3 className="text-xl md:text-2xl font-bold mb-4">Follow Us</h3>
          <ul className="social-links">
  <li><Link to="/" className="hover:text-blue-500 disabled" title="coming soon .." disabled>Facebook</Link></li>
  <li><Link to="/" className="hover:text-blue-500 disabled" disabled>Twitter</Link></li>
  <li><Link to="/" className="hover:text-blue-500 disabled" disabled>Instagram</Link></li>
  <li><Link to="/" className="hover:text-blue-500 disabled" disabled>LinkedIn</Link></li>
      </ul>
        </div>
        <div className="footer-section m-auto">
          <h3 className="text-xl md:text-2xl font-bold mb-4">Contact Information</h3>
          {/* <p className="mb-4">Street Name</p> */}
          {/* <p className="mb-4">City, State, </p> */}
          <p className="mb-4">+91 9306726036</p>
          <p >amankirmara143@gmail.com</p>
        </div>
      </div>
      <div className="containerBottom mx-auto mt-8 text-center">
        <p>&copy; 2024 student.webgeniuscraft.com All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
